(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9557],{

/***/ 75670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowAltRightDark = function SvgArrowAltRightDark(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1 1L8 8L1 15",
    stroke: "#52575C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowAltRightDark);

/***/ }),

/***/ 28058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Shimmer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/shimmer/node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
;// CONCATENATED MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Shimmer-module_shimmer__3pOKa{animation:Shimmer-module_a-background-move__3AzYv 1.5s infinite;background-image:linear-gradient(90deg,#f7f7f7,#dcdcdc,#f7f7f7);background-size:200%;border-radius:var(--size-border-radius-base)}.Shimmer-module_shimmer__3pOKa.Shimmer-module_rounded__3tSiD{border-radius:50%}@keyframes Shimmer-module_a-background-move__3AzYv{0%{background-position:100%}to{background-position:-100%}}";
var styles = {"shimmer":"Shimmer-module_shimmer__3pOKa","a-background-move":"Shimmer-module_a-background-move__3AzYv","rounded":"Shimmer-module_rounded__3tSiD","aBackgroundMove":"Shimmer-module_a-background-move__3AzYv"};
styleInject(css_248z);

var Shimmer = react.forwardRef(function (_a, ref) {
    var _b = _a.height, height = _b === void 0 ? 16 : _b, _c = _a.width, width = _c === void 0 ? 100 : _c, rounded = _a.rounded, style = _a.style, className = _a.className, _d = _a.noOfLines, noOfLines = _d === void 0 ? 1 : _d, props = __rest(_a, ["height", "width", "rounded", "style", "className", "noOfLines"]);
    var classes = clsx_m(styles.shimmer, rounded && styles.rounded, className);
    var lines = new Array(noOfLines).fill('');
    return (react.createElement(react.Fragment, null, lines.map(function (_line, idx) { return (react.createElement("div", __assign({ className: classes, style: Object.assign({}, { width: width, height: height }, __assign({}, style)) }, props, { ref: ref, key: idx }))); })));
});




/***/ }),

/***/ 99158:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/text/[id]",
      function () {
        return __webpack_require__(84496);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useMateriRouterCheck = function(isRouterReady, query) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), routerQueryIsNotComplete = ref[0], setRouterQueryIsNotComplete = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isRouterReady && (!query.modul || !query.materi)) {
            setRouterQueryIsNotComplete(true);
        }
    }, [
        query,
        isRouterReady
    ]);
    return routerQueryIsNotComplete;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMateriRouterCheck);


/***/ }),

/***/ 84496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@wartek-id/header-bar/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(89140);
// EXTERNAL MODULE: ./node_modules/@wartek-id/fe-toolbox/dist/history.mjs
var dist_history = __webpack_require__(72955);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/@wartek-id/shimmer/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(28058);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js + 1 modules
var text_dist_index_esm = __webpack_require__(89004);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 1 modules
var icon_dist_index_esm = __webpack_require__(21958);
// EXTERNAL MODULE: ./api/microlearning/useAPIMateri.ts
var useAPIMateri = __webpack_require__(47080);
// EXTERNAL MODULE: ./utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(7379);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/components/QueryNotCompleteError.tsx
var QueryNotCompleteError = __webpack_require__(25536);
// EXTERNAL MODULE: ./app/PelatihanMandiriPage/hooks/useMateriRouterCheck.ts
var useMateriRouterCheck = __webpack_require__(24703);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Materi/TextMateriContent.tsx



var TextMateriContent = function(param) {
    var title = param.title, content = param.content, _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-4 bg-white border border-subduedrounded-lg overflow-y-auto",
        style: {
            height: "calc(100vh - ".concat(isDesktop ? 16 : 9.5, "rem)")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-[14px] leading-relaxed",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                    variant: "heading-md",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                as: "div",
                className: "simple-wysiwyg-content material-content",
                dangerouslySetInnerHTML: {
                    __html: content
                }
            })
        ]
    });
};
/* harmony default export */ var Materi_TextMateriContent = (TextMateriContent);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./assets/icons/arrow-alt-right-dark.svg
var arrow_alt_right_dark = __webpack_require__(75670);
;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/partials/Materi/TextMateriPageNavigation.tsx





var TextMateriPageNavigation = function(param) {
    var currentIndex = param.currentIndex, totalPage = param.totalPage, onPrevious = param.onPrevious, onNext = param.onNext;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute left-0 bottom-0 flex items-center justify-between px-4 h-16 w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                "data-testid": "prev-button",
                as: "button",
                type: "button",
                className: (0,clsx_m/* default */.Z)("flex items-center justify-start w-[44px] h-[44px] focus:outline-none", currentIndex === 0 && "opacity-20"),
                onClick: onPrevious,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_alt_right_dark/* default */.Z, {
                    className: "transform rotate-180"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tracking-wider",
                children: [
                    "Halaman ",
                    currentIndex + 1,
                    "/",
                    totalPage
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                "data-testid": "next-button",
                as: "button",
                type: "button",
                className: (0,clsx_m/* default */.Z)("flex items-center justify-end w-[44px] h-[44px] focus:outline-none", currentIndex + 1 === totalPage && "opacity-20"),
                onClick: onNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_alt_right_dark/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var Materi_TextMateriPageNavigation = (TextMateriPageNavigation);

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/pages/MateriText.tsx

















var MateriText = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? false : _isDesktop;
    var ref, ref1, ref2;
    var ref3 = (0,next_router.useRouter)(), query = ref3.query, isRouterReady = ref3.isReady, back = ref3.back;
    var isRouterInvalid = (0,useMateriRouterCheck/* default */.Z)(isRouterReady, query);
    var ref4 = (0,useAPIMateri/* useGetMateriText */.gi)(query.modul, query.materi, query.id), isSuccess = ref4.isSuccess, isLoading = ref4.isLoading, materiContent = ref4.data;
    var _recordProgress = query.recordProgress, recordProgress = _recordProgress === void 0 ? "true" : _recordProgress;
    var shouldRecordProgress = recordProgress === "true";
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), currentPage = ref5[0], setCurrentPage = ref5[1];
    var isProgressSent = react.useRef(false);
    var ref6 = (0,useAPIMateri/* usePostMateriProgress */.i$)(query.modul, query.materi, {
        onSuccess: function() {
            isProgressSent.current = true;
        }
    }), saveProgress = ref6.mutateAsync;
    (0,react.useEffect)(function() {
        var ref;
        if (isSuccess && !!(materiContent === null || materiContent === void 0 ? void 0 : (ref = materiContent.data) === null || ref === void 0 ? void 0 : ref.contents) && materiContent.data.contents.length === 1 && !isProgressSent.current) {
            var ref1;
            shouldRecordProgress && saveProgress({
                id: materiContent === null || materiContent === void 0 ? void 0 : (ref1 = materiContent.data) === null || ref1 === void 0 ? void 0 : ref1.id,
                type: "text"
            });
        }
    }, [
        isSuccess,
        materiContent === null || materiContent === void 0 ? void 0 : materiContent.data,
        saveProgress,
        shouldRecordProgress
    ]);
    (0,react.useEffect)(function() {
        if (isSuccess) {
            var ref;
            (0,googleAnalytics/* GATrackEvent */.l)({
                eventName: "learning_activity",
                eventParams: {
                    event_trigger: "module_open_text",
                    action_type: "open_material_text",
                    meta: JSON.stringify({
                        learning_id: materiContent === null || materiContent === void 0 ? void 0 : (ref = materiContent.data) === null || ref === void 0 ? void 0 : ref.id,
                        material_id: query.materi,
                        module_id: query.modul
                    })
                },
                sendDefaultParams: true
            });
        }
    }, [
        isSuccess,
        materiContent,
        query
    ]);
    var handleOnPageChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(index) {
            var ref, ref1, ref2, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setCurrentPage(index);
                        if (!(!isProgressSent.current && index + 1 >= (materiContent === null || materiContent === void 0 ? void 0 : (ref = materiContent.data) === null || ref === void 0 ? void 0 : (ref1 = ref.contents) === null || ref1 === void 0 ? void 0 : ref1.length))) return [
                            3,
                            3
                        ];
                        _tmp = shouldRecordProgress;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            saveProgress({
                                id: materiContent === null || materiContent === void 0 ? void 0 : (ref2 = materiContent.data) === null || ref2 === void 0 ? void 0 : ref2.id,
                                type: "text"
                            })
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnPageChange(index) {
            return _ref.apply(this, arguments);
        };
    }();
    var gotoPreviousPage = function(event) {
        event.preventDefault();
        setCurrentPage(function(oldPage) {
            if (oldPage === 0) {
                return oldPage;
            }
            return oldPage - 1;
        });
        window.scrollTo(0, 0);
    };
    var gotoNextPage = function(event) {
        event.preventDefault();
        setCurrentPage(function(oldPage) {
            var ref, ref1;
            if (oldPage + 1 >= (materiContent === null || materiContent === void 0 ? void 0 : (ref = materiContent.data) === null || ref === void 0 ? void 0 : (ref1 = ref.contents) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                return oldPage;
            }
            return oldPage + 1;
        });
        window.scrollTo(0, 0);
    };
    if (isRouterInvalid) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryNotCompleteError/* default */.Z, {});
    }
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "p-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-4 bg-white border border-subdued rounded-lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Shimmer */.q, {
                    height: 12,
                    noOfLines: 9,
                    className: "mb-4 last:mb-0",
                    style: {
                        width: "100%"
                    }
                })
            })
        });
    }
    if (isDesktop) {
        var ref7, ref8, ref9, ref10;
        var ref11, ref12;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Pelatihan Mandiri | Materi ",
                            (ref11 = materiContent === null || materiContent === void 0 ? void 0 : (ref7 = materiContent.data) === null || ref7 === void 0 ? void 0 : ref7.name) !== null && ref11 !== void 0 ? ref11 : " Text"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row",
                    children: [
                        query.from && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.J, {
                            as: "i",
                            className: "mr-2",
                            onClick: back,
                            children: "arrow_back"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    className: "pb-1",
                                    children: "MATERI"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                    className: "pb-1",
                                    variant: "heading-lg",
                                    children: (ref12 = materiContent === null || materiContent === void 0 ? void 0 : (ref8 = materiContent.data) === null || ref8 === void 0 ? void 0 : ref8.name) !== null && ref12 !== void 0 ? ref12 : " Text"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative py-[18px]",
                    style: {
                        minHeight: "calc(100vh - 11rem)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
                            interval: 1000 * 60 * 60,
                            showThumbs: false,
                            autoPlay: false,
                            selectedItem: currentPage,
                            showArrows: false,
                            showStatus: false,
                            showIndicators: false,
                            preventMovementUntilSwipeScrollTolerance: true,
                            swipeScrollTolerance: 50,
                            onChange: handleOnPageChange,
                            children: materiContent === null || materiContent === void 0 ? void 0 : (ref9 = materiContent.data) === null || ref9 === void 0 ? void 0 : ref9.contents.map(function(content, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat(isDesktop ? "" : "px-4", " text-left"),
                                    "data-testid": "page-".concat(index + 1),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Materi_TextMateriContent, {
                                        title: materiContent.data.name,
                                        content: content,
                                        isDesktop: isDesktop
                                    })
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Materi_TextMateriPageNavigation, {
                            currentIndex: currentPage,
                            totalPage: materiContent === null || materiContent === void 0 ? void 0 : (ref10 = materiContent.data) === null || ref10 === void 0 ? void 0 : ref10.contents.length,
                            onPrevious: gotoPreviousPage,
                            onNext: gotoNextPage
                        })
                    ]
                })
            ]
        });
    }
    var ref13;
    return isSuccess && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Pelatihan Mandiri | Materi ",
                        (ref13 = materiContent === null || materiContent === void 0 ? void 0 : (ref = materiContent.data) === null || ref === void 0 ? void 0 : ref.name) !== null && ref13 !== void 0 ? ref13 : " Text"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative py-[18px] bg-gray-5",
                style: {
                    minHeight: "calc(100vh - 3.5rem)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
                        interval: 1000 * 60 * 60,
                        showThumbs: false,
                        autoPlay: false,
                        selectedItem: currentPage,
                        showArrows: false,
                        showStatus: false,
                        showIndicators: false,
                        preventMovementUntilSwipeScrollTolerance: true,
                        swipeScrollTolerance: 50,
                        onChange: handleOnPageChange,
                        children: materiContent === null || materiContent === void 0 ? void 0 : (ref1 = materiContent.data) === null || ref1 === void 0 ? void 0 : ref1.contents.map(function(content, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isDesktop ? "" : "px-4", " text-left"),
                                "data-testid": "page-".concat(index + 1),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Materi_TextMateriContent, {
                                    title: materiContent === null || materiContent === void 0 ? void 0 : materiContent.data.name,
                                    content: content,
                                    isDesktop: isDesktop
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Materi_TextMateriPageNavigation, {
                        currentIndex: currentPage,
                        totalPage: materiContent === null || materiContent === void 0 ? void 0 : (ref2 = materiContent.data) === null || ref2 === void 0 ? void 0 : ref2.contents.length,
                        onPrevious: gotoPreviousPage,
                        onNext: gotoNextPage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_MateriText = (MateriText);

// EXTERNAL MODULE: ./components/Layout/Desktop/DesktopLayout.tsx
var DesktopLayout = __webpack_require__(72351);
// EXTERNAL MODULE: ./assets/icons/close.svg
var icons_close = __webpack_require__(17436);
;// CONCATENATED MODULE: ./pages/pelatihan-mandiri/text/[id].tsx








var MateriTextPage = function(props) {
    var isDesktopScreenSize = props.isDesktopScreenSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopLayout/* WithLayoutListener */.nc, {
        isDesktop: isDesktopScreenSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_MateriText, {
            isDesktop: isDesktopScreenSize
        })
    });
};
var PageHeader = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBar */.h_, {
        fixed: true,
        className: "z-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HeaderBarLeftAction */.l8, {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {
                className: "stroke-current text-default"
            }),
            onClick: function() {
                return dist_history/* backToApp */.NU(router.back);
            }
        })
    });
};
MateriTextPage.layoutOpts = {
    hasHeader: true,
    className: "text-default bg-gray-5",
    header: PageHeader,
    enableDesktopLayout: true
};
/* harmony default export */ var _id_ = (MateriTextPage);


/***/ }),

/***/ 52165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WU": function() { return /* reexport */ format; },
  "z2": function() { return /* reexport */ register; }
});

// UNUSED EXPORTS: cancel, render

;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/lang/en_US.js
var EN_US = ['second', 'minute', 'hour', 'day', 'week', 'month', 'year'];
/* harmony default export */ function en_US(diff, idx) {
    if (idx === 0)
        return ['just now', 'right now'];
    var unit = EN_US[Math.floor(idx / 2)];
    if (diff > 1)
        unit += 's';
    return [diff + " " + unit + " ago", "in " + diff + " " + unit];
}
//# sourceMappingURL=en_US.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/lang/zh_CN.js
var ZH_CN = ['秒', '分钟', '小时', '天', '周', '个月', '年'];
/* harmony default export */ function zh_CN(diff, idx) {
    if (idx === 0)
        return ['刚刚', '片刻后'];
    var unit = ZH_CN[~~(idx / 2)];
    return [diff + " " + unit + "\u524D", diff + " " + unit + "\u540E"];
}
//# sourceMappingURL=zh_CN.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/register.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
/**
 * All supported locales
 */
var Locales = {};
/**
 * register a locale
 * @param locale
 * @param func
 */
var register = function (locale, func) {
    Locales[locale] = func;
};
/**
 * get a locale, default is en_US
 * @param locale
 * @returns {*}
 */
var register_getLocale = function (locale) {
    return Locales[locale] || Locales['en_US'];
};
//# sourceMappingURL=register.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/utils/date.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */
var SEC_ARRAY = [
    60,
    60,
    24,
    7,
    365 / 7 / 12,
    12,
];
/**
 * format Date / string / timestamp to timestamp
 * @param input
 * @returns {*}
 */
function toDate(input) {
    if (input instanceof Date)
        return input;
    // @ts-ignore
    if (!isNaN(input) || /^\d+$/.test(input))
        return new Date(parseInt(input));
    input = (input || '')
        // @ts-ignore
        .trim()
        .replace(/\.\d+/, '') // remove milliseconds
        .replace(/-/, '/')
        .replace(/-/, '/')
        .replace(/(\d)T(\d)/, '$1 $2')
        .replace(/Z/, ' UTC') // 2017-2-5T3:57:52Z -> 2017-2-5 3:57:52UTC
        .replace(/([+-]\d\d):?(\d\d)/, ' $1$2'); // -04:00 -> -0400
    return new Date(input);
}
/**
 * format the diff second to *** time ago, with setting locale
 * @param diff
 * @param localeFunc
 * @returns
 */
function date_formatDiff(diff, localeFunc) {
    /**
     * if locale is not exist, use defaultLocale.
     * if defaultLocale is not exist, use build-in `en`.
     * be sure of no error when locale is not exist.
     *
     * If `time in`, then 1
     * If `time ago`, then 0
     */
    var agoIn = diff < 0 ? 1 : 0;
    /**
     * Get absolute value of number (|diff| is non-negative) value of x
     * |diff| = diff if diff is positive
     * |diff| = -diff if diff is negative
     * |0| = 0
     */
    diff = Math.abs(diff);
    /**
     * Time in seconds
     */
    var totalSec = diff;
    /**
     * Unit of time
     */
    var idx = 0;
    for (; diff >= SEC_ARRAY[idx] && idx < SEC_ARRAY.length; idx++) {
        diff /= SEC_ARRAY[idx];
    }
    /**
     * Math.floor() is alternative of ~~
     *
     * The differences and bugs:
     * Math.floor(3.7) -> 4 but ~~3.7 -> 3
     * Math.floor(1559125440000.6) -> 1559125440000 but ~~1559125440000.6 -> 52311552
     *
     * More information about the performance of algebraic:
     * https://www.youtube.com/watch?v=65-RbBwZQdU
     */
    diff = Math.floor(diff);
    idx *= 2;
    if (diff > (idx === 0 ? 9 : 1))
        idx += 1;
    return localeFunc(diff, idx, totalSec)[agoIn].replace('%s', diff.toString());
}
/**
 * calculate the diff second between date to be formatted an now date.
 * @param date
 * @param relativeDate
 * @returns {number}
 */
function date_diffSec(date, relativeDate) {
    var relDate = relativeDate ? toDate(relativeDate) : new Date();
    return (+relDate - +toDate(date)) / 1000;
}
/**
 * nextInterval: calculate the next interval time.
 * - diff: the diff sec between now and date to be formatted.
 *
 * What's the meaning?
 * diff = 61 then return 59
 * diff = 3601 (an hour + 1 second), then return 3599
 * make the interval with high performance.
 **/
function date_nextInterval(diff) {
    var rst = 1, i = 0, d = Math.abs(diff);
    for (; diff >= SEC_ARRAY[i] && i < SEC_ARRAY.length; i++) {
        diff /= SEC_ARRAY[i];
        rst *= SEC_ARRAY[i];
    }
    d = d % rst;
    d = d ? rst - d : rst;
    return Math.ceil(d);
}
//# sourceMappingURL=date.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/format.js


/**
 * format a TDate into string
 * @param date
 * @param locale
 * @param opts
 */
var format = function (date, locale, opts) {
    // diff seconds
    var sec = date_diffSec(date, opts && opts.relativeDate);
    // format it with locale
    return date_formatDiff(sec, register_getLocale(locale));
};
//# sourceMappingURL=format.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/realtime.js



// all realtime timer
var TIMER_POOL = {};
/**
 * clear a timer from pool
 * @param tid
 */
var clear = function (tid) {
    clearTimeout(tid);
    delete TIMER_POOL[tid];
};
// run with timer(setTimeout)
function run(node, date, localeFunc, opts) {
    // clear the node's exist timer
    clear(getTimerId(node));
    var relativeDate = opts.relativeDate, minInterval = opts.minInterval;
    // get diff seconds
    var diff = diffSec(date, relativeDate);
    // render
    node.innerText = formatDiff(diff, localeFunc);
    var tid = setTimeout(function () {
        run(node, date, localeFunc, opts);
    }, Math.min(Math.max(nextInterval(diff), minInterval || 1) * 1000, 0x7fffffff));
    // there is no need to save node in object. Just save the key
    TIMER_POOL[tid] = 0;
    setTimerId(node, tid);
}
/**
 * cancel a timer or all timers
 * @param node - node hosting the time string
 */
function cancel(node) {
    // cancel one
    if (node)
        clear(getTimerId(node));
    // cancel all
    // @ts-ignore
    else
        Object.keys(TIMER_POOL).forEach(clear);
}
/**
 * render a dom realtime
 * @param nodes
 * @param locale
 * @param opts
 */
function render(nodes, locale, opts) {
    // by .length
    // @ts-ignore
    var nodeList = nodes.length ? nodes : [nodes];
    nodeList.forEach(function (node) {
        run(node, getDateAttribute(node), getLocale(locale), opts || {});
    });
    return nodeList;
}
//# sourceMappingURL=realtime.js.map
;// CONCATENATED MODULE: ./node_modules/timeago.js/esm/index.js
/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */



register('en_US', en_US);
register('zh_CN', zh_CN);



//# sourceMappingURL=index.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1958,8189,615,1529,6367,9774,2888,179], function() { return __webpack_exec__(99158); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);